import { Routes } from '@angular/router';
import { DefaultLayoutComponent } from './layout';
import { LoginComponent } from '@infra-ui/views/auth/login/login.component';
import { AuthGuard } from '@infra-adapters/guards/auth.guard';
import { PermissionGuard } from '@infra-adapters/guards/permission.guard';
import { BackofficePermission } from '@core-interfaces/global/permissions';
import { RecoverPasswordComponent } from '@infra-ui/views/auth/recover-password/recover-password.component';
import { ForceChangePasswordComponent } from '@infra-ui/views/auth/force-change-password/force-change-password.component';
import { FirstLoginGuard, FirstLoginChildGuard } from '@infra-adapters/guards/first-login.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home'
    },
    canActivate: [AuthGuard, FirstLoginGuard],
    canActivateChild: [FirstLoginChildGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/routes').then((m) => m.routes)
      },
      {
        path: 'categorias',
        canActivate: [PermissionGuard],
        data: { permission: BackofficePermission.CATALOG_VIEW_CATEGORIES },
        loadChildren: () => import('./views/categories/routes').then((m) => m.routes)
      },
      {
        path: 'servicios',
        canActivate: [PermissionGuard],
        data: { permission: BackofficePermission.CATALOG_VIEW_SERVICES },
        loadChildren: () => import('./views/services/routes').then((m) => m.routes)
      },
      {
        path: 'usuarios',
        loadChildren: () => import('./views/users/routes').then((m) => m.routes)
      },
      {
        path: 'pedidos',
        loadChildren: () => import('./views/pedidos/routes').then((m) => m.routes)
      },
      {
        path: 'roles',
        canActivate: [PermissionGuard],
        data: { permission: BackofficePermission.ROLES_VIEW },
        loadChildren: () => import('./views/roles/routes').then((m) => m.routes)
      },
      {
        path: 'ride-modalities',
        canActivate: [PermissionGuard],
        data: { permission: BackofficePermission.RIDE_MODALITIES_VIEW },
        loadChildren: () => import('./views/ride-modalities/routes').then((m) => m.routes)
      },
      {
        path: 'catalogo-vehiculos',
        canActivate: [PermissionGuard],
        data: { permission: BackofficePermission.VEHICLE_CATALOG_VIEW },
        loadChildren: () => import('./views/vehicle-catalog/routes').then((m) => m.routes)
      },
      {
        path: 'configuraciones',
        canActivate: [PermissionGuard],
        data: { permission: BackofficePermission.SYSTEM_CONFIGS_VIEW },
        loadChildren: () => import('./views/system-config/routes').then((m) => m.routes)
      },
      {
        path: 'tickets',
        loadChildren: () => import('./views/tickets/routes').then((m) => m.routes)
      },
      {
        path: 'banners',
        canActivate: [PermissionGuard],
        data: { permission: BackofficePermission.BANNERS_VIEW },
        loadChildren: () => import('./views/banners/routes').then((m) => m.routes)
      },
      {
        path: 'correo-electronico',
        canActivate: [PermissionGuard],
        data: { permission: BackofficePermission.EMAIL_VIEW_LOGS },
        loadChildren: () => import('./views/email/routes').then((m) => m.routes)
      },
      {
        path: 'notificaciones-push',
        canActivate: [PermissionGuard],
        data: { permission: BackofficePermission.PUSH_NOTIFICATIONS_VIEW },
        loadChildren: () => import('./views/push-notifications/routes').then((m) => m.routes)
      },
      {
        path: 'cupones',
        canActivate: [PermissionGuard],
        data: { permission: BackofficePermission.COUPONS_VIEW },
        loadChildren: () => import('./views/coupons/routes').then((m) => m.routes)
      },
      {
        path: 'liquidaciones',
        canActivate: [PermissionGuard],
        data: { permission: BackofficePermission.SETTLEMENTS_VIEW },
        loadChildren: () => import('./views/settlements/routes').then((m) => m.routes)
      },
      {
        path: 'retiros',
        canActivate: [PermissionGuard],
        data: { permission: BackofficePermission.WITHDRAWALS_VIEW },
        loadChildren: () => import('./views/withdrawals/routes').then((m) => m.routes)
      },
      {
        path: 'sos',
        loadChildren: () => import('./views/sos/routes').then((m) => m.routes)
      },
      {
        path: 'mensajes',
        canActivate: [PermissionGuard],
        data: { permission: BackofficePermission.MESSAGES_VIEW },
        loadChildren: () => import('./views/messages/routes').then((m) => m.routes)
      },
      {
        path: 'mi-cuenta',
        loadComponent: () => import('./views/account/mi-cuenta.component').then((m) => m.MiCuentaComponent),
        data: { title: 'Mi cuenta' },
      },
    ]
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    // Página pública de seguimiento de emergencia (SOS): no requiere login,
    // se autoriza con el token del link (?token=).
    path: 'seguimiento-emergencia',
    loadComponent: () =>
      import('./views/emergency-tracking/emergency-tracking.component').then(
        (m) => m.EmergencyTrackingComponent,
      ),
  },
  {
    path: 'recuperar-contrasena',
    component: RecoverPasswordComponent,
  },
  {
    path: 'cambiar-contrasena-inicial',
    component: ForceChangePasswordComponent,
    canActivate: [AuthGuard],
  },
  { path: '**', redirectTo: 'dashboard' }
];
